import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Services extends CommonCRUD {}

export default Services;
